<template>
  <b-modal
    id="DashboardMonitoring"
    title="Configurações"
    no-close-on-backdrop
    hide-footer
    hide-header-close
    size="md"
    modal-class="config-modal"
  >
    <div class="config-content">
      <div class="config-section">
        <h4 class="section-title">
          <i class="fas fa-sync-alt mr-2"></i>
          Atualização Automática
        </h4>

        <div class="time-options">
          <div
            v-for="option in timeOptions"
            :key="option.value"
            class="time-option"
            :class="{ active: autoUpdateInterval === option.value }"
            @click="autoUpdateInterval = option.value"
          >
            <div class="option-time">{{ option.label }}</div>
          </div>
        </div>

        <div class="custom-time" v-if="autoUpdateInterval === 'custom'">
          <input
            type="number"
            v-model="customMinutes"
            min="1"
            max="120"
            class="custom-input"
            placeholder="Minutos"
          />
          <span class="input-suffix">min</span>
        </div>
      </div>

      <div class="config-section">
        <h4 class="section-title">
          <i class="fas fa-volume-up mr-2"></i>
          Alertas de Voz
        </h4>

        <div class="voice-controls">
          <select v-model="selectedVoice" class="form-select">
            <option value="0">Voz Padrão do Sistema</option>
            <option
              v-for="(voice, index) in availableVoices"
              :key="index"
              :value="index"
            >
              {{ voice.name }} ({{ voice.lang }})
            </option>
          </select>

          <button
            type="button"
            @click="testVoice"
            class="btn-test-voice"
            :disabled="testing"
          >
            <i
              :class="testing ? 'fas fa-spinner fa-spin' : 'fas fa-play'"
              class="mr-1"
            ></i>
            {{ testing ? "Testando" : "Testar" }}
          </button>
        </div>
      </div>

      <div class="config-actions">
        <button
          type="button"
          @click="$bvModal.hide('DashboardMonitoring')"
          class="btn-modern btn-modern-delete"
        >
          Cancelar
        </button>
        <button
          type="button"
          @click="saveSettings"
          class="btn-modern btn-modern-save"
        >
          <i class="fas fa-save mr-1"></i>
          Salvar
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "DashboardMonitoringConfig",

  data() {
    return {
      autoUpdateInterval: 30,
      customMinutes: 30,
      selectedVoice: 0,
      availableVoices: [],
      testing: false,
      currentUtterance: null,

      timeOptions: [
        // { value: 5, label: "5min" },
        // { value: 15, label: "15min" },
        { value: 30, label: "30min" },
        { value: 60, label: "1h" },
        // { value: "custom", label: "Custom" },
      ],
    };
  },

  computed: {
    finalUpdateInterval() {
      if (this.autoUpdateInterval === "custom") {
        return parseInt(this.customMinutes) || 30;
      }
      return this.autoUpdateInterval;
    },
  },

  mounted() {
    this.loadVoices();
    this.loadSettings();
  },

  beforeDestroy() {
    this.stopCurrentTest();
  },

  methods: {
    loadVoices() {
      const loadVoicesWhenAvailable = () => {
        const voices = speechSynthesis.getVoices();

        this.availableVoices = voices;
      };

      loadVoicesWhenAvailable();

      if (speechSynthesis.onvoiceschanged !== undefined) {
        speechSynthesis.onvoiceschanged = loadVoicesWhenAvailable;
      }

      setTimeout(loadVoicesWhenAvailable, 1000);
    },

    loadSettings() {
      const savedInterval = localStorage.getItem(
        "sistemaclin_dashboard_update_interval"
      );
      const savedVoice = localStorage.getItem(
        "sistemaclin_dashboard_monitoring_voice"
      );

      if (savedInterval) {
        const interval = parseInt(savedInterval);
        if ([5, 15, 30, 60].includes(interval)) {
          this.autoUpdateInterval = interval;
        } else {
          this.autoUpdateInterval = "custom";
          this.customMinutes = interval;
        }
      }

      if (savedVoice) {
        this.selectedVoice = parseInt(savedVoice) || 0;
      }
    },

    saveSettings() {
      localStorage.setItem(
        "sistemaclin_dashboard_update_interval",
        this.finalUpdateInterval
      );
      localStorage.setItem(
        "sistemaclin_dashboard_monitoring_voice",
        this.selectedVoice
      );

      this.$emit("save", {
        autoUpdateInterval: this.finalUpdateInterval,
        voice: this.selectedVoice,
      });
    },

    async testVoice() {
      if (this.testing) {
        this.stopCurrentTest();
        return;
      }

      this.testing = true;

      try {
        speechSynthesis.cancel();

        const testText = "Sistema de monitoramento configurado com sucesso.";
        this.currentUtterance = new SpeechSynthesisUtterance(testText);

        this.currentUtterance.lang = "pt-BR";
        this.currentUtterance.rate = 0.9;
        this.currentUtterance.volume = 1;
        this.currentUtterance.pitch = 1;

        if (
          this.selectedVoice > 0 &&
          this.availableVoices[this.selectedVoice]
        ) {
          this.currentUtterance.voice =
            this.availableVoices[this.selectedVoice];
        }

        this.currentUtterance.onend = () => {
          this.testing = false;
          this.currentUtterance = null;
        };

        this.currentUtterance.onerror = () => {
          this.testing = false;
          this.currentUtterance = null;
        };

        speechSynthesis.speak(this.currentUtterance);

        setTimeout(() => {
          if (this.testing) {
            this.stopCurrentTest();
          }
        }, 6000);
      } catch (error) {
        this.testing = false;
        this.currentUtterance = null;
      }
    },

    stopCurrentTest() {
      speechSynthesis.cancel();
      this.testing = false;
      this.currentUtterance = null;
    },
  },
};
</script>

<style scoped>
.config-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-bottom: 1px solid #e5e7eb;
  padding: 16px 20px;
}

.modal-title-custom {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

.config-content {
  padding: 20px;
}

.config-section {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f5f9;
}

.config-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #0f65b0;
}

/* Time Options - Compact Grid */
.time-options {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  margin-bottom: 12px;
}

.time-option {
  padding: 10px 8px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.time-option:hover {
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

.time-option.active {
  border-color: #0f65b0;
  background: #eff6ff;
  color: #0f65b0;
}

.option-time {
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}

/* Custom Time Input - Inline */
.custom-time {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.custom-input {
  width: 80px;
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s ease;
  text-align: center;
}

.custom-input:focus {
  border-color: #0f65b0;
  box-shadow: 0 0 0 2px rgba(15, 101, 176, 0.1);
}

.input-suffix {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}

/* Voice Controls - Inline */
.voice-controls {
  display: flex;
  gap: 8px;
  align-items: center;
}

.form-select {
  flex: 1;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  outline: none;
  transition: border-color 0.2s ease;
}

.form-select:focus {
  border-color: #0f65b0;
  box-shadow: 0 0 0 2px rgba(15, 101, 176, 0.1);
}

.btn-test-voice {
  padding: 10px 16px;
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-width: 80px;
}

.btn-test-voice:hover:not(:disabled) {
  background: #e2e8f0;
  transform: translateY(-1px);
}

.btn-test-voice:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Actions */
.config-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
  margin-top: 16px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
}

.btn-cancel {
  background: #f8fafc;
  color: #475569;
  border: 1px solid #e2e8f0;
}

.btn-cancel:hover {
  background: #f1f5f9;
  transform: translateY(-1px);
}

.btn-save {
  background: #0f65b0;
  color: white;
}

.btn-save:hover {
  background: #1e40af;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(15, 101, 176, 0.3);
}

/* Spinner animation */
.fa-spin {
  animation: fa-spin 1s infinite linear;
}

@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .config-content {
    padding: 16px;
  }

  .time-options {
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
  }

  .time-option {
    padding: 8px 6px;
    min-height: 40px;
  }

  .option-time {
    font-size: 13px;
  }

  .voice-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-test-voice {
    min-width: auto;
  }

  .config-actions {
    flex-direction: column;
  }

  .btn {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .time-options {
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
  }

  .time-option {
    padding: 6px 4px;
    min-height: 36px;
  }

  .option-time {
    font-size: 12px;
  }

  .custom-input {
    width: 60px;
  }

  .form-select {
    font-size: 13px;
    padding: 8px 10px;
  }

  .btn-test-voice {
    font-size: 12px;
    padding: 8px 12px;
  }
}
</style>